import './inc/event-tracking';
import './inc/open-links-in-new-tab';
import './inc/highlight-toc-menu';
import './inc/countdown';

import './inc/sticky';

jQuery(document).ready(function ($) {
    $(window).trigger('ntz-image-loaded');
    $('img').each((i, img) => {
        const isOffScreen = $(img).offset().top > $(window).height();

        $(img).on('load', () => {
            $(window).trigger('ntz-image-loaded', [isOffScreen]);
        });
    });
})
